<script setup lang="ts">
const { result, isSubmitting, onSubmit, onReset } = useUpdateAccountForm();
</script>

<template>
  <UiFormWrapper :result="result" @submit="onSubmit" @reset="onReset">
    <div class="grid gap-4 lg:grid-cols-2">
      <FieldText name="first_name" type="text" label="Prénom" required />
      <FieldText name="last_name" type="text" label="Nom" required />
    </div>
    <FieldText name="display_name" type="text" label="Nom d'affichage" required />
    <FieldDatePicker name="birthday" label="Date de naissance" />
    <UiSubmitButton :is-submitting="isSubmitting" />
  </UiFormWrapper>
</template>
